<template>
  <div class="main">
    <slot :response="response" :loading="loading"></slot>
  </div>
</template>

<script>
// require modules
import * as d3 from "d3";

const _ = require('lodash');

export default {
  name: "FetchPADCsvItem",
  props: ['id'],
  data() {
    return {
      loading: true,
      response: '',
    }
  },
  methods: {
    zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    async getItems() {
      const vm = this;

      let id = vm.zeroPad(vm.id, 4)
      let data = await d3.csv(`/csv/EMBD${id}_hits_matrix.csv`);
      data = data.slice(1)

      vm.loading = false;
      vm.response = data;
    }
  },
  mounted() {
    const vm = this
    // /* eslint-disable no-console */
    // console.log(vm.id);
    vm.getItems();
  },
}
</script>

<style scoped>
.main {
  margin: 1.5rem;
}
</style>